import { useEffect } from 'react';
import { checkAuthToken } from '@/utils/authUtils';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Heart, LogIn } from 'lucide-react';

const SprkzHelp = () => {

  useEffect(() => {
    if (checkAuthToken()) {
      document.location.href = '/sprkz/?view=health';
    }
  }, []);

  const handleLogin = () => {
    const redirect = encodeURIComponent('/sprkz/?view=health');
    sessionStorage.setItem('post_login_redirect', '/sprkz/?view=health');
    // Break out of iframe for auth flow to avoid CSP frame-ancestors issues
    window.location.href = `/login?post_login_redirect=${redirect}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Heart className="h-12 w-12 text-primary" />
          </div>
          <CardTitle>Access your Health Score</CardTitle>
          <CardDescription>
            Sign in to connect your session. Once signed in, you'll be redirected
            back to the Sprkz view.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          <Button onClick={handleLogin} className="w-full max-w-sm">
            <LogIn className="mr-2" /> Sign in
          </Button>
          <p className="text-sm text-muted-foreground text-center">
            If this page is embedded in Sprkz and you already signed in, it will
            auto-redirect to the health view.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default SprkzHelp;


